import { Modal, Form, Input, Message } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'
import { updateUserInfoApi } from '@/api/user'
import { getFormValidateErrorMessage } from '@/utils/helpers'
import type { SecureRunner } from '@/hooks/useSecureVerification'

interface ChangePasswordModalProps {
  visible: boolean
  onClose: () => void
  runSecure: SecureRunner
}

export default function ChangePasswordModal({ visible, onClose, runSecure }: ChangePasswordModalProps) {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const submit = async () => {
    try {
      const values = await form.validate()
      if (values.password !== values.password2) {
        Message.error(t('auth.passwordMismatch'))
        return
      }
      await runSecure(
        () =>
          updateUserInfoApi({
            original_password: values.original_password,
            password: values.password,
          }),
        { scope: 'account.password.change' }
      )
      Message.success(t('personal.security.passwordUpdated'))
      form.resetFields()
      onClose()
    } catch (err: unknown) {
      if (err instanceof Error && err.message !== t('用户取消了二次验证')) {
        Message.error(getFormValidateErrorMessage(err))
      }
    }
  }

  return (
    <Modal
      title={t('personal.passwordModal.title')}
      visible={visible}
      onCancel={onClose}
      onOk={() => void submit()}
      unmountOnExit
    >
      <Form form={form} layout="vertical">
        <Form.Item field="original_password" label={t('personal.passwordModal.original')} rules={[{ required: true }]}>
          <Input.Password />
        </Form.Item>
        <Form.Item field="password" label={t('personal.passwordModal.new')} rules={[{ required: true }]}>
          <Input.Password />
        </Form.Item>
        <Form.Item field="password2" label={t('personal.passwordModal.confirm')} rules={[{ required: true }]}>
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  )
}
